import { useRouterState } from "@tanstack/react-router";

// The old page stays on screen until the next one's code has arrived, so without this a tap on a
// slow phone network looked ignored and got repeated. The fade-in delay keeps a fast navigation
// from flashing it.
export function NavigationProgress() {
    const pending = useRouterState({ select: (state) => state.status === "pending" });
    if (!pending) return null;

    return (
        <div
            role="progressbar"
            aria-label="Loading page"
            className="pointer-events-none fixed inset-x-0 top-0 z-40 h-0.5 bg-foreground transition-opacity delay-150 duration-200 starting:opacity-0"
        />
    );
}
